<template>
    <div class="l-wrap">
        <div class="l-constrained l-content quote">

            <el-container v-loading="! initialized">
                <el-form style="width:100%">

                    <el-row>
                        <el-col :span="12">
                            <h1>Edit Quote</h1>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <template v-if="form_data.employer_id">
                                <btn icon="fas fa-fast-backward" :click="goBack">Go Back to Quote Tool</btn>
                                <btn icon="fas fa-step-backward" :click="goToEmployerDetail">Go Back to Employer's Quotes</btn>
                            </template>
                            <template v-else>
                                <btn icon="fas fa-step-backward" :click="goBack">Go Back to Quote Tool</btn>
                            </template>
                            <btn icon="fas fa-copy" :click="cloneQuote" :disabled="data.is_location_based === 1">Clone</btn>
                        </el-col>
                    </el-row>

                    <el-row v-if="data.is_location_based === 1">
                        <el-col :span="24">
                            <el-alert
                                title="Location Based Quote"
                                type="warning"
                                description="This quote was generated automatically by the system. It's functionality is limited for preview only - you cannot save it or change audience. For any changes please contact DEV team."
                                show-icon>
                            </el-alert>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Name</h2>
                            <el-input v-model="form_data.name"></el-input>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Employer</h2>
                            <el-select
                                v-model="form_data.employer_id"
                                filterable
                                clearable
                                :trigger-on-focus="false"
                                class="full-width"
                                placeholder="Select an employer">
                                <el-option
                                    v-for="item in employers"
                                    :key="`emp-${item.id}`"
                                    :label="item.name + ' (' + item.id + ')' + (item.state !== 'Active' ? ` (${item.state})` : '')"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <QuotePrefill v-if="data.is_location_based === 0" :employer_id="form_data.employer_id" @prefill="prefill"/>

                    <template v-if="data.campaign_names || data.job_ids">
                        <div class="prefill-wrapper" style="margin-top: 20px;">
                            <el-switch
                                style="float: right;"
                                v-model="form_data.strict_campaign_match"
                                active-text="Use current campaign setup"
                                inactive-text="Edit geo or experience">
                            </el-switch>

                            <template v-if="data.campaign_names">
                                <p style="margin-bottom:8px"><b>Match drivers by campaign {{ data.campaign_names }}</b></p>
                                <p v-if="form_data.strict_campaign_match">Estimates below are based on jobs currently setup under campaign {{ data.campaign_names }}.</p>
                                <p v-if="!form_data.strict_campaign_match">Estimates are based on the values filled in below and may not reflect the campaign's actual capacity.</p>
                            </template>
                            <template v-if="data.job_ids">
                                <p style="margin-bottom:8px"><b>Match drivers by job(s) {{ data.job_ids }}</b></p>
                                <p v-if="form_data.strict_campaign_match">Estimates below are based on the current setup of job(s) {{ data.job_ids }}.</p>
                                <p v-if="!form_data.strict_campaign_match">Estimates are based on the values filled in below and may not reflect the campaign's actual capacity.</p>
                            </template>
                        </div>
                    </template>
                    <template  v-if="!form_data.strict_campaign_match">

                    <JobFormMap v-if="initialized && data.is_location_based === 0"
                                :google-api-key="google_api_key"
                                :area-id="form_data.area_id"
                                :maps-url="maps_url"
                                :is-tr-user="true"
                                :has-error="mapsHasError"/>

                    <el-row>
                        <el-col :span="24">
                            <h2>Audience</h2>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Min Experience">
                                <el-select v-model="form_data.min_cdl_xp" style="width:100%" required="required">
                                    <el-option
                                        v-for="option in globals.cdl_xp"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="`min-xp-${option.id}`"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Max Experience">
                                <el-select v-model="form_data.max_cdl_xp" style="width:100%">
                                    <el-option
                                        v-for="option in globals.cdl_xp"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="`max-xp-${option.id}`"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <budget-categories :formData="form_data"></budget-categories>
                        </el-col>
                        <el-col :span="24">
                          <el-form-item label="Wasn't sent to employer">
                            <el-select v-model="form_data.wasnt_sent_to_employer" style="width:100%" clearable filterable>
                              <el-option
                                  v-for="option in employers"
                                  :value="option.id"
                                  :label="option.name + (option.state == 'Inactive' ? ' (Inactive)' : '')"
                                  :key="option.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2>Multi-Carrier</h2>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Multi-Carrier strict matching">
                                <div style="clear: both">
                                    <!--div class="cd-section">
                                        <el-checkbox v-model="form_data.mc_strict.match_equipment_interest">Exact match equipment interest</el-checkbox>
                                        ( <el-checkbox v-model="form_data.mc_strict.match_equipment_interest_undefined">or undefined</el-checkbox> )
                                    </div-->

                                    <div class="cd-section">
                                        <el-checkbox v-model="form_data.mc_strict.match_equipment_experience">Exact match equipment experience</el-checkbox>
                                        ( <el-checkbox v-model="form_data.mc_strict.match_equipment_experience_undefined">or undefined</el-checkbox> )
                                    </div>

                                    <div class="cd-section">
                                        <el-checkbox v-model="form_data.mc_strict.match_route">Exact match route</el-checkbox>
                                        ( <el-checkbox v-model="form_data.mc_strict.match_route_undefined">or undefined</el-checkbox> )
                                    </div>

                                    <div class="cd-section">
                                        <el-checkbox v-model="form_data.mc_strict.match_teams">Exact match teams</el-checkbox>
                                        ( <el-checkbox v-model="form_data.mc_strict.match_teams_undefined">or undefined</el-checkbox> )
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <template v-if="form_data.deja.is_visible_to_user">
                        <el-row>
                            <el-col :span="24">
                                <h2>DEJA</h2>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <span style="width: 175px; display: inline-block; vertical-align: middle">Include drivers as old as</span>
                                <el-input-number style="width:100px" :controls="false" v-model="form_data.deja.last_sent_to_ats_from_months"></el-input-number>
                                <span style="width: 100px; display:inline-block; vertical-align:middle">months</span>
                            </el-col>
                            <el-col :span="24" style="padding-top:10px">
                                <span style="width: 175px; display: inline-block; vertical-align: middle">Include drivers who have received between</span>
                                <el-input-number style="width: 100px" :controls="false" v-model="form_data.deja.received_calls_min"></el-input-number>
                                <span style="width: 100px; display: inline-block; vertical-align: middle">and</span>
                                <el-input-number style="width: 100px" :controls="false" v-model="form_data.deja.received_calls_max"></el-input-number>
                                <span style="width: 100px; display: inline-block; vertical-align: middle">calls</span>
                            </el-col>
                        </el-row>
                    </template>

                    </template>

                    <el-row>
                        <el-col :span="24">
                            <h2 style="margin-bottom:0">Pricing</h2>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <quote-pricing :employerId="form_data.employer_id" :formData="form_data.pricing"></quote-pricing>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <h2 style="margin-bottom:0">Base suggestions on data from period</h2>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="From">
                                <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd"
                                                format="yyyy-MM-dd" v-model="form_data.date_from"
                                                style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="To">
                                <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd"
                                                format="yyyy-MM-dd" v-model="form_data.date_to"
                                                style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <btn :disabled="data.is_location_based === 1" :click="saveAudience" cssClass="btn btn-primary btn-lg">Save Audience and Get Results</btn>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <quote-detail-results :refresh_index="refresh_index" :quote_id="quote_id"></quote-detail-results>

                </el-form>
            </el-container>
        </div>


    </div>
</template>

<script>
import JobFormMap from './../../../maps/vue/map.vue';
import BudgetCategories from "./budget-categories";
import QuotePricing from "./quote-pricing";
import QuoteDetailResults from "./quote-detail-results";
import QuotePrefill from "./quote-prefill";

export default {
    props: [
        'data',
        'google_api_key',
        'maps_url',
    ],
    components: {
        QuoteDetailResults,
        QuotePricing,
        BudgetCategories,
        JobFormMap,
        QuotePrefill
    },
    data() {
        return {
            form_data: this.data,
            mapsHasError: false,
            employers: [],
            loading: false,
            area_ready: false,
            quote_id: this.data.id,
            refresh_index: 1,
        };
    },
    computed: {
        initialized() {
            return ! this.loading && this.area_ready;
        },
    },
    methods: {
        startAreaSession(quoteId) {
            this.area_ready = false,

            axios.post(this.url(`admin/area/start-session`), {
                quote_id: quoteId
            }).then(response => {
                this.form_data.area_id = response.data.id;

                this.area_ready = true;
            });
        },
        cloneQuote() {
            window.location.href = url(`admin/quotes/${this.quote_id}/clone`);
        },
        goBack() {
            window.location.href = url(`admin/quotes/list`);
        },
        goToEmployerDetail() {
            window.location.href = url(`admin/employer/${this.form_data.employer_id}/quotes`);
        },
        saveAudience() {
            this.loading = true;
            return axios.post(url(`admin/quotes/${this.quote_id}/update`), {
                'name': this.form_data.name,
                'employer_id': this.form_data.employer_id,

                'strict_campaign_match': this.form_data.strict_campaign_match,
                'area_id': this.form_data.area_id,

                'min_cdl_xp': this.form_data.min_cdl_xp,
                'max_cdl_xp': this.form_data.max_cdl_xp,
                'categories': this.form_data.categories,
                'pricing': this.form_data.pricing,
                'wasnt_sent_to_employer': this.form_data.wasnt_sent_to_employer,
                'mc_strict': this.form_data.mc_strict,
                'deja': this.form_data.deja,
                'date_from': this.form_data.date_from,
                'date_to': this.form_data.date_to,
            }).then((result) => {
                ++this.refresh_index;
                this.quote_id = result.data.id;

                this.startAreaSession(this.quote_id);
            }).finally(() => {
                this.loading = false;
            });
        },
        refresh() {
            this.startAreaSession(this.quote_id);

            axios.get(url(`admin/employers/dropdown`), { params: { inactive: 1 } })
                .then((response) => {
                    this.employers = response.data;
                });
        },
        prefill(e) {
            const jobId = encodeURIComponent((e.job_id || []).join(','));
            const campaignId = encodeURIComponent((e.campaign_id || []).join(','));

            const self = this;
            self.loading = true;

            axios.get(url(`admin/quotes/${this.quote_id}/prefill?jobs_id=${jobId}&campaigns_id=${campaignId}`))
                 .then((response) => {
                     location.reload();
                 });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
.quote h2 {
    margin-top: 50px !important;
}

.quote .prefill-wrapper {
    background-color: #f4f4f5;
    border-radius: 4px;
    padding: 10px 24px;
    overflow: hidden;
    color: #909399;
}

.quote .prefill-wrapper .btn {
    float: right;
    margin: 9px 0 0 8px;
}

.quote .prefill-wrapper p {
    margin-bottom: 0;
}
</style>
